<app-datatable
  [dataSource]="userSource"
  [columns]="columns"
  [identifier]="'secondary-users'"
  [customActions]="customActions"
  [actionNew]="false"
>
  <app-empty-table
    [icon]="'person'"
    [emptyText]="'user.secondary-user.empty_text' | translate"
  >
  </app-empty-table>
</app-datatable>

<app-error [error]="error"></app-error>

<app-model-modal #EditModal (saveEvent)="onSave()">
  <app-user-form
    #form
    (closeEvent)="onModalClose()"
    (loadingEvent)="onLoading($event.valueOf())"
  ></app-user-form>
</app-model-modal>
